export const paperSize: string[] = ["a3", "a4", "a5"];
export const orientations: string[] = ["landscape", "portrait"];
